import { TemperatureBreach } from 'seacube-backend/src/api/client';

import { store } from './store';

export const setTemperatureBreachesMinDuration = (duration: number) => {
  store.temperatureBreaches.minDuration = duration;
  setFilteredTemperatureBreaches();
};

export const setTemperatureBreachesMinDeviation = (deviation: number) => {
  store.temperatureBreaches.minDeviation = deviation;
  setFilteredTemperatureBreaches();
};

export const setRawTemperatureBreaches = (
  temperatureBreaches: TemperatureBreach[],
) => {
  store.temperatureBreaches.raw = temperatureBreaches;
  setFilteredTemperatureBreaches();
};

export const setFilteredTemperatureBreaches = () => {
  store.temperatureBreaches.filtered = store.temperatureBreaches.raw.filter(
    (p: TemperatureBreach) => {
      const start = new Date(p.start_datetime).getTime();
      const end = new Date(p.end_datetime).getTime();
      const durationHours = (end - start) / (1000 * 60 * 60);

      const condDuration =
        durationHours >= store.temperatureBreaches.minDuration;
      const condDeviation =
        p.max_deviation >= store.temperatureBreaches.minDeviation;
      return true;
      return condDuration && condDeviation;
    },
  );
};
